import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'
import template from './calendar-list.hbs'
import calendarListItem from './calendar-list-item.hbs'
import calendars from 'scoreboard/components/calendars'
import CalendarForm from './calendar-form'
import appDisplay from 'scoreboard/components/app-display'
import i18n from 'scoreboard/components/i18n'
import Tree from 'kalpa-tree'
import streamify from 'stream-array'
import * as d3 from 'd3-selection'

var CalendarList = Backbone.View.extend({

	className: 'panel search-panel has-draggable-list left-panel',

	events: {
		'click .add-calendar': 'addCalendar',
		'click .list li': 'selectCalendar'
	},

	initialize: function(options) {
		this.options = options || {}
	},

	render: function() {
		this.resetCalendars()
		return this
	},

	selectCalendar: function(e, el) {
		var item = el || $(e.target).closest('li')[0]
		var id = item.dataset.id
		var selected
		_.each(calendars.calendars, function(calendar) {
			if(calendar.id == id) {
				selected = calendar
			}
		})
		this.trigger('select:calendar', selected)
		this.$('li.selected').removeClass('selected')
		$(item).toggleClass('selected')
		this.options.calendarId = id
	},

	addCalendar: function() {
		var form = new CalendarForm({ calendar: {} })
		appDisplay.dialog(form)
		form.on('done', function(calendar) {
			this.$('ul.list').append(calendarListItem(_.extend({}, calendar, {
				isCustom: calendar.type == 'custom'
			})))
			this._createDraggableList()
			this.$('.no-calendars').addClass('is-not-displayed')
			// After adding a new calendar, select it
			this.tree.once('rendered', () => {
				this.selectCalendar(null, this.$('ul.list li:last-child')[0])
			})
		}.bind(this))
	},

	// Completely resets the calendar list by re-rendering the calendar list html
	// and re creating the draggable list.
	resetCalendars: function(calendar) {
		this.$el.empty().append(template())
		this._createDraggableList()
	},

	// Renders or re-renders the html for the draggable list
	_renderCalendarList: function() {
		var context = { noCalendars: i18n.get('common.thereAreNo', 'common.calendar.calendars') }
		this.$el.empty().append(template(context))
		if (_.isEmpty(calendars.calendars)) {
			this.$('.no-calendars').removeClass('is-not-displayed')
			return
		}

		var html = ''
		_.each(calendars.calendars, function(calendar) {
			html += calendarListItem(_.extend({}, calendar, {
				isCustom: calendar.type == 'custom'
			}))
		})

		this.$('.admin-list-view-search-results .list').append(html)
	},

	// Creates or re-creates the draggable calendar list and sets the correct
	// default selected item.
	_createDraggableList: function() {
		_.invokeMap([this.tree], 'remove')

		this.tree = new Tree({
			forest: true,
			stream: streamify(calendars.calendars),
			height: 78, // height of the nodes in this screen (must match whats in calendar-list.scss)
			contents: function(selection, tree, transitions) {
				selection.each(function (data) {
					var calendar = tree.nodes[data.id]
					var isCustom = calendar.type =='custom'

					var node = d3.select(this)
					,	contents = node.selectAll('.content-wrapper')
							.data(function (d) {
								return [d]
							})
					,	enter = contents.enter()
							.append('div')
							.attr('class', function() {
								if (isCustom) {
									return 'content-wrapper is-custom'
								} else {
									return 'content-wrapper'
								}
							})

					enter.append('h3')
						.html(_.escape(calendar.label))

					if (isCustom) {
						enter.append('h5')
							.html(_.escape(calendar.type))
					}

					enter.append('svg')
							.attr('class', 'icon-grip')
							.append('use')
							.attr('xlink:href', '#icon-grip')

				})
			},
			droppable: function (node, parent) {
				return !parent
			}
		}).render()
		this.tree.editable()

		this.$('.admin-list-view-search-results').append(this.tree.el.node())
		// This tree needs to appear like a draggable list, so append the list related classes
		// to help that along.
		this.$('.tree ul').addClass('list secondary-rows draggable-list')

		this.tree.on('dndmove', () => this._drawListStripes(this.tree.root))
		this.tree.on('dndstart', () => this.$('.tree').addClass('dragging'))

		this.tree.on('rendered', () => {
			this.tree.select(this.options.calendarId)
			this._drawListStripes()
			this.trigger('treeRendered')
		})

		this.tree.on('move', node => {
			var newIndex
			_.each(this.tree.root, (n, i) => {
				if (node.id == n.id) {
					newIndex = i
				}
			})

			$.ajax({
				method: 'post',
				url: 'api/admin/calendars/' + node.id + '/reorder?index=' + newIndex,
				success: calendars.reset.bind(calendars)
			})
		})
	},

	// Go through and add .is-striped to the proper tree nodes. This is needed
	// since the tree nodes aren't in the same order in the DOM as they are
	// visually, so we can't just use css's nth-child(odd) except for the first time
	// when the nodes are in order like they're shown.
	_drawListStripes: function(order) {
		this.$('.tree li').removeClass('is-striped')

		if (_.isNil(order)) {
			this.$('.tree li:nth-child(odd)').addClass('is-striped')
			return
		}

		var odd = true
		_.each(order, o => {
			this.$(`.tree li[data-id=${o.id}]`).toggleClass('is-striped', odd)
			odd = !odd
		})
	},

	getTreeHeight: function() {
		var treeHeight = this.tree.el.node().querySelectorAll('.tree ul li').length * this.tree.options.height
		return treeHeight
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.draggableList], 'remove')
	}

})

export default CalendarList

CalendarList.__filename__ = 'admin/calendars/calendar-list.js'
